export default [
  // 后台状态码
  {
    key: '2',
    zh_CN: '服务器异常',
    en: 'Server Exception',
    de: 'Serverausnahme',
    nl: 'Uitzondering Server'
  }
]
